export const Icons = {
  'coffee-logo': require('./images/coffee.svg'),
  'down-rating-coffee': require('./images/down-rating-coffee.svg'),
  'up-rating-coffee': require('./images/up-rating-coffee.svg'),
  'left-chevron': require('./images/left-chevron.svg'),
  'right-chevron': require('./images/right-chevron.svg'),
  'cart': require('./images/cart.svg')
};

export const Errors = {
  'none': '',
  'empty_content': require('./images/undraw_empty_xct9.svg')
};

export const Defaults = {
  'product_image': 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=300&h=300&q=72',
  'store_image': 'https://images.unsplash.com/photo-1485182708500-e8f1f318ba72?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=450&h=300&q=72'
};
